import { useQuery } from "react-query";
import endpoints from "./EndPoints"
import { getCurrencyList } from "./Services";


export const useCurrencies = () => {
  return useQuery([endpoints.getCurrencies], () => getCurrencyList(), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};


